<template>
  <div :class="insetClasses && [insetClasses, inlineMarginMap[alignment]]">
    <component
      :is="component"
      :class="[
        brandClasses?.content,
        classes,
        {
          '<lg:[&_img]:w-full ': !componentSidePaddings?.sm && id,
          'lg:[&_img]:w-full': !componentSidePaddings?.lg && id,
          'overflow-x-auto': richText?.html.includes('<table'),
        },
        sidePadding && paddings[sidePadding],
      ]"
      :content="richText?.html"
      data-test-id="cms-rich-text"
      :options="component === CmsRichTextAdvanced ? dynamicFields : undefined"
      :style="{ '--ch': linksHoverColor }"
    />
  </div>
</template>

<script lang="ts" setup>
import type { RichTextContent } from '#types/components/cms/rich-text'
import { CmsRichTextAdvanced, CmsRichTextStandard } from '#components'
import { DynamicFieldsKey } from '#content/contexts/dynamic-fields'

const { content, linksHoverColor } = defineProps<{
  content: RichTextContent
  linksHoverColor?: string
}>()

const {
  alignment = 'center',
  componentSidePaddings,
  countdown,
  id,
  richText,
  sidePadding,
} = content

const cms = useAppConfig().components.cms
const { brandClasses } = cms.richText || {}
const insetClasses = getContentInset(content, cms.section, true)

const classes = `vf-9ua34e [&_sup,&_sub]:text-60%`

const paddings = {
  medium: 'px-4 lg:px-6'
}

const inlineMarginMap = {
  left: 'mx-0',
  center: 'mx-a'
}

const dynamicFields = countdown ? { countdown } : inject(DynamicFieldsKey, undefined)

const component = dynamicFields && richText?.html.includes('data-component') ? CmsRichTextAdvanced : CmsRichTextStandard
</script>
